<docs>
What is difference?
       “addToCartAllowed”: false, (button is Gone alltogether)
       “addToCartDisabled”: false, (Grayed out)

Which one makes it grayed out and which one removes the button altogether

Ryan Holliday [2:19 PM]
those may need some updating from STH, but disabled = greyed out, allowed = show/hide the button.

</docs>

<template v-if="product">
  <li :class="productClass" v-if="productDataIsGoodEnoughToDisplayCard">
    <!-- START: NORMAL PRODUCT CARD -->
    <template v-if="size == 'normal'">
      <a
        :href="this.productSafe.pdpUrl"
        @click.prevent="handleProductLink"
        :aria-label="ariaLabel"
      >
        <img
          :src="flag.imgUrl"
          :class="flag.class"
          v-if="flag"
          @click.stop.prevent="
            flag.onClick ? flag.onClick() : handleProductLink()
          "
          alt
        />
        <div class="responsivegriditem-top">
          <div :class="gtmImpressionClass">
            <img :src="productSafe.smallImageUrl" alt loading="lazy" />
            <script type="application/ld+json">
              {{ jsonld }}
            </script>
          </div>
        </div>
        <div class="responsivegriditem-middle">
          <div class="responsivegriditem__title">
            <span class="responsivegriditem__title">
              <span v-html="productSafe.displayName"></span>
              <span
                v-if="productSafe.defaultSku.customerFriendlySize"
                class="item-size"
                >, {{ productSafe.defaultSku.customerFriendlySize }}</span
              >
            </span>
          </div>
          <div
            class="cat-price"
            v-if="productSafe.defaultSku.priceInfo.listPrice"
          >
            <div v-if="productSafe.isAtStartingPrice">Starting at</div>
            <div class="responsivegriditem__strikethrough">
              <del
                v-if="productSafe.onSale"
                class="responsivegriditem__price-label"
                >{{ productSafe.defaultSku.priceInfo.listPrice.formatted }}
                {{ productSafe.defaultSku.priceInfo.listPrice.unit }}</del
              >
            </div>
            <span v-if="!productSafe.onSale" class="cat-price-number">
              {{ productSafe.defaultSku.priceInfo.listPrice.formatted }}
              {{ productSafe.defaultSku.priceInfo.listPrice.unit }}
              <span
                v-if="productSafe.defaultSku.priceInfo.unitListPrice.length"
                class="cat-unit-price"
                >({{
                  productSafe.defaultSku.priceInfo.unitListPrice.formatted
                }}/{{
                  productSafe.defaultSku.priceInfo.unitListPrice.unit
                }})</span
              >
            </span>

            <span
              v-if="productSafe.onSale"
              class="cat-price-number"
              v-bind:class="{
                'responsivegriditem__price-on-sale': productSafe.onSale,
              }"
            >
              {{ productSafe.defaultSku.priceInfo.salePrice.formatted }}
              {{ productSafe.defaultSku.priceInfo.salePrice.unit }}
              <span
                v-if="
                  productSafe.defaultSku.priceInfo.unitSalePrice.formatted
                    .length
                "
                class="cat-unit-price"
                >({{
                  productSafe.defaultSku.priceInfo.unitSalePrice.formatted
                }}/{{
                  productSafe.defaultSku.priceInfo.unitSalePrice.unit
                }})</span
              >
            </span>
          </div>
          <div class="cdp-moq"></div>
        </div>
      </a>
      <div class="responsivegriditem-bottom">
        <div class="product-card__cart-actions">
          <preference-add-to-bucket
            v-if="displayPreferences"
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :verticalPosition="preferenceVerticalPosition"
            v-on:show-coupon-one-to-one-card="seeCoupons()"
          >
          </preference-add-to-bucket>
          <add-to-bucket
            v-else
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :position="position"
            v-on:show-coupon-one-to-one-card="seeCoupons()"
          >
          </add-to-bucket>
          <button
            class="textBrowserOnly"
            v-if="
              productSafe.defaultSku.availableCouponIds.length === 1 &&
              options.showCoupons === true
            "
            @click.stop="seeCoupons"
          >
            Open Coupon Details
          </button>
          <product-card-coupon-popup
            v-if="
              productSafe.defaultSku.availableCouponIds.length === 1 &&
              options.showCoupons === true &&
              showCouponPopup
            "
            @closeCouponPopup="closeCouponPopup"
            :couponId="productSafe.defaultSku.availableCouponIds[0]"
            aria-role="dialog"
            aria-live="assertive"
          ></product-card-coupon-popup>
          <button
            v-if="options.showAddToList === true"
            class="btn btn-list btn-full-width"
            @click="addToListButton"
            :aria-expanded="showLists ? 'true' : 'false'"
            aria-haspopup="true"
            ref="addToListButtonRef"
            @focus="changeFocus"
          >
            Add to list
          </button>
          <transition name="fade">
            <div
              class="list-wrapper"
              v-show="showLists"
              @keydown.esc.prevent="closeLists"
            >
              <div
                class="atl-container product-recordatl-container product-record"
                :class="{ overflow: lists.length > 5 }"
              >
                <ul class="shoppingListSelector" role="menu">
                  <li v-for="(list, index) in lists" v-bind:key="index">
                    <span v-if="list.id">
                      <button
                        @click="addItemToList(list.id, list.name)"
                        ref="listItem"
                        :data-ref-index="index"
                        :aria-label="`Add to list.name}`"
                        @focus="changeFocus"
                        @keydown.down.prevent="
                          () => {
                            nextListItem('next');
                          }
                        "
                        @keydown.up.prevent="
                          () => {
                            nextListItem('prev');
                          }
                        "
                        role="menuitem"
                      >
                        {{ list.name }}
                      </button>
                    </span>
                    <span v-else>
                      <a
                        href="/my-list/shopping-list"
                        ref="listItem"
                        :data-ref-index="index"
                        @keydown.down.prevent="
                          () => {
                            nextListItem('next');
                          }
                        "
                        @keydown.up.prevent="
                          () => {
                            nextListItem('prev');
                          }
                        "
                        @focus="changeFocus"
                        @keydown.tab="closeLists"
                        role="menuitem"
                        >Manage My Lists</a
                      >
                    </span>
                  </li>
                </ul>

                <div class="atl-container-triangle"></div>
              </div>
            </div>
          </transition>
          <!-- TODO: Show the flyout -->
          <!-- @click="javascript:addToListFromCategory(productSafe.productId, productSafe.skuId, '${profile.activeshoppinglist.id}', '${unknownItemId}'); return false;" -->
        </div>
      </div>
    </template>
    <!-- END: NORMAL PRODUCT CARD -->
    <!-- START: MEDIUM PRODUCT CARD -->
    <template v-if="size == 'medium'">
      <a
        :href="this.productSafe.pdpUrl"
        @click.prevent="handleProductLink"
        :aria-label="ariaLabel"
      >
        <div class="product-card__top gtm-product">
          <img :src="flag.imgUrl" :class="flag.class" v-if="flag" alt />
          <img
            :src="productSafe.smallImageUrl"
            alt
            loading="lazy"
            class="product-card__thumbnail"
          />
          <script type="application/ld+json">
            {{ jsonld }}
          </script>
        </div>
        <div class="product-card__meta">
          <div class="product-card__display-name">
            <span v-html="productSafe.displayName"></span>
            <span
              v-if="productSafe.defaultSku.customerFriendlySize"
              class="item-size"
              >, {{ productSafe.defaultSku.customerFriendlySize }}</span
            >
          </div>

          <div
            class="product-card__price-container mb-1"
            :class="{ 'product-card__on-sale': productSafe.onSale }"
          >
            <div
              v-if="productSafe.isAtStartingPrice"
              class="product-card__starting-at"
            >
              Starting at
            </div>
            <div>
              <div class="list-price">
                <span class="product-card__price mr-1">{{
                  productSafe.defaultSku.priceInfo.listPrice.formatted
                }}</span>
                <!-- Start if: Show price per oz, or "each" -->
                <span
                  v-if="
                    productSafe.defaultSku.priceInfo.unitListPrice.formatted
                      .length
                  "
                  class="product-card__unit"
                >
                  ({{
                    productSafe.defaultSku.priceInfo.unitListPrice.formatted
                  }}/{{ productSafe.defaultSku.priceInfo.unitListPrice.unit }})
                </span>
                <span v-else class="product-card__unit">
                  {{ productSafe.defaultSku.priceInfo.listPrice.unit }}
                </span>
              </div>
              <!-- End if: Show price per oz, or "each" -->
              <div v-if="productSafe.onSale" class="sale-price">
                <span class="product-card__price">{{
                  productSafe.defaultSku.priceInfo.salePrice.formatted
                }}</span>
                <span class="product-card__unit">
                  {{ productSafe.defaultSku.priceInfo.salePrice.unit }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </a>
      <preference-add-to-bucket
        v-if="displayPreferences"
        :product="product"
        :bucket="bucket"
        :listname="listname"
        :verticalPosition="preferenceVerticalPosition"
      >
      </preference-add-to-bucket>
      <add-to-bucket
        v-else
        :product="product"
        :bucket="bucket"
        :listname="listname"
        :position="position"
      >
      </add-to-bucket>
    </template>
    <!-- END: MEDIUM PRODUCT CARD -->
    <!-- START: SMALL PRODUCT CARD -->
    <template v-if="size == 'small'" :aria-label="ariaLabel">
      <div class="d-flex product-card__meta">
        <div :class="gtmImpressionClassSmall">
          <a
            :href="this.productSafe.pdpUrl"
            @click.prevent="handleProductLink"
            aria-hidden="true"
          >
            <img
              :src="productSafe.thumbnailImageUrl"
              alt
              class="product-card__thumbnail"
              role="presentation"
              loading="lazy"
            />
          </a>
          <script type="application/ld+json">
            {{ jsonld }}
          </script>
        </div>
        <div class="product-card__content-container">
          <div class="product-card__description mb-1">
            <a
              :href="this.productSafe.pdpUrl"
              @click.prevent="handleProductLink"
              class="product-card__title"
            >
              <span v-html="productSafe.displayName"></span>
              <span
                v-if="productSafe.defaultSku.customerFriendlySize"
                class="item-size"
                >, {{ productSafe.defaultSku.customerFriendlySize }}</span
              >
            </a>
          </div>
          <div class="product-card__price-container mb-1">
            <div
              v-if="productSafe.isAtStartingPrice"
              class="product-card__starting-at"
            >
              Starting at
            </div>
            <div>
              <span v-if="productSafe.onSale">
                <span class="product-card__price">{{
                  productSafe.defaultSku.priceInfo.salePrice.formatted
                }}</span>
                <span class="product-card__unit"
                  >/{{ productSafe.defaultSku.priceInfo.salePrice.unit }}</span
                >
              </span>
              <span v-else>
                <span class="product-card__price">{{
                  productSafe.defaultSku.priceInfo.listPrice.formatted
                }}</span>
                <span class="product-card__unit"
                  >/{{ productSafe.defaultSku.priceInfo.listPrice.unit }}</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="product-card__cart-actions">
        <div v-if="location === 'normal'">
          <preference-add-to-bucket
            v-if="displayPreferences"
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :verticalPosition="preferenceVerticalPosition"
          >
          </preference-add-to-bucket>
          <add-to-bucket
            v-else
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :position="position"
          >
          </add-to-bucket>
        </div>
        <div v-else-if="location === 'CDM' && orderContext === 'curbside'">
          <preference-add-to-bucket
            v-if="displayPreferences && !hideAddToCartBtn"
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :verticalPosition="preferenceVerticalPosition"
          >
          </preference-add-to-bucket>
          <add-to-bucket
            v-else
            :product="product"
            :bucket="bucket"
            :listname="listname"
            :position="position"
            :hideAddToCartBtn="hideAddToCartBtn"
          ></add-to-bucket>
        </div>
      </div>
    </template>
    <!-- END: SMALL PRODUCT CARD -->
  </li>
</template>

<script>
import ProductCardCouponPopup from "./ProductCardCouponPopup";
import AddToBucket from "../AddToBucket";
import PreferenceAddToBucket from "../preferences/PreferenceAddToBucket";
import {
  PRODUCT_ADD_TO_LIST_EVENT,
  PRODUCT_CLICK_EVENT,
  PDP_CLICK_THROUGH_EVENT,
} from "../../utilities/constants";

import _ from "lodash";

export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
    },
    size: {
      type: String,
      default: "normal",
    },
    location: {
      type: String,
      default: "normal", //normal, CDM. Product card in CDM behaves slightly differently.
    },
    bucket: {
      type: String,
      default: "cart", // cart, orderAddOns. Used for figuring out how many are in your bucket
    },
    productLinkDestination: {
      type: String,
      default: "link", // link, modal. A switch that choose how to handle the destination of clicking on a link in the product card
    },
    listname: {
      type: String,
      default: "",
    },
    position: {
      type: Number,
      default: 1,
    },
    reco: {
      type: String,
      default: "default",
    },
    collection: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({
        showCoupons: true,
        showAddToList: true,
        overrideAddToBucket: false,
      }),
    },
    hideAddToCartBtn: {
      type: Boolean,
      default: false,
    },
    productClassName: {
      type: String,
    },
    hidePreferences: {
      type: Boolean, // Whether to hide the preference component on the product card.
      default: false, // Currently set to true for some instances where there are display issues with the preference popover.
    },
    preferenceVerticalPosition: {
      type: String,
      default: "bottom", // top, bottom. Determines default positioning of preference popover.
    },
  },
  components: {
    "product-card-coupon-popup": ProductCardCouponPopup,
    "add-to-bucket": AddToBucket,
    "preference-add-to-bucket": PreferenceAddToBucket,
  },
  data() {
    return {
      showCouponPopup: false,
      orderContext: window.heb.data.user.orderContext,
      weight: 0,
      showLists: false,
      focusedRef: "",
      errorMessage: false,
    };
  },
  computed: {
    jsonld() {
      const obj = {
        name: this.productSafe.displayName,
        id: this.productSafe.id,
        category: this.productSafe.defaultLevelOneCategory.name,
        brand: this.productSafe.brand,
        variant: this.productSafe.defaultSku.priceInfo.listPrice.unit,
        price:
          this.productSafe.defaultSku.priceInfo.listPrice.formatted.replace(
            "$",
            ""
          ) || 0.0,
        list: this.formattedListName,
        position: this.position,
        dimension26: this.productSafe.ownBrand || false,
        dimension40: this.reco,
      };

      return JSON.stringify(obj);
    },
    productSafe() {
      // HUP-4121
      // the product model can have missing properties
      // Here we are sure they exist

      var productSafe = {
        addToCartAllowed: _.get(this.product, "addToCartAllowed", false),
        addToCartDisabled: _.get(this.product, "addToCartDisabled", false),
        brand: _.get(this.product, "brand", ""),
        defaultLevelOneCategory: {
          id: _.get(this.product, "defaultLevelOneCategory.name", ""),
          name: _.get(this.product, "defaultLevelOneCategory.name", ""),
        },
        defaultSku: {
          contextPrices: [
            {
              salePrice: {
                unit: _.get(
                  this.product,
                  "defaultSku.contextPrices[0].salePrice",
                  ""
                ),
                formatted: _.get(
                  this.product,
                  "defaultSku.contextPrices[0].formatted",
                  ""
                ),
              },
              priceType: _.get(
                this.product,
                "defaultSku.contextPrices[0].priceType",
                ""
              ),
              context: _.get(
                this.product,
                "defaultSku.contextPrices[0].context",
                ""
              ),
              listPrice: {
                unit: _.get(
                  this.product,
                  "defaultSku.contextPrices[0].listPrice.unit",
                  ""
                ),
                formatted: _.get(
                  this.product,
                  "defaultSku.contextPrices[0].listPrice.formatted",
                  ""
                ),
              },
            },
            {
              salePrice: {
                unit: _.get(
                  this.product,
                  "defaultSku.contextPrices[1].salePrice",
                  ""
                ),
                formatted: _.get(
                  this.product,
                  "defaultSku.contextPrices[1].formatted",
                  ""
                ),
              },
              priceType: _.get(
                this.product,
                "defaultSku.contextPrices[1].priceType",
                ""
              ),
              context: _.get(
                this.product,
                "defaultSku.contextPrices[1].context",
                ""
              ),
              listPrice: {
                unit: _.get(
                  this.product,
                  "defaultSku.contextPrices[1].listPrice.unit",
                  ""
                ),
                formatted: _.get(
                  this.product,
                  "defaultSku.contextPrices[1].listPrice.formatted",
                  ""
                ),
              },
            },
          ],
          couponIds: _.get(this.product, "defaultSku.couponIds", []),
          availableCouponIds: _.get(
            this.product,
            "defaultSku.availableCouponIds",
            []
          ),
          customerFriendlySize: _.get(
            this.product,
            "defaultSku.customerFriendlySize",
            ""
          ),
          customerPurchaseChoice: _.get(
            this.product,
            "defaultSku.customerPurchaseChoice",
            ""
          ),
          displayName: _.get(this.product, "defaultSku.displayName", ""),
          fulfillmentChannelAvailability: _.get(
            this.product,
            "defaultSku.fulfillmentChannelAvailability",
            []
          ),
          id: _.get(this.product, "defaultSku.id", ""),
          onSale: _.get(this.product, "defaultSku.onSale", ""),
          priceInfo: {
            unitListPrice: {
              unit: _.get(
                this.product,
                "defaultSku.priceInfo.unitListPrice.unit",
                ""
              ),
              formatted: _.get(
                this.product,
                "defaultSku.priceInfo.unitListPrice.formatted",
                ""
              ),
            },
            salePrice: {
              unit: _.get(
                this.product,
                "defaultSku.priceInfo.salePrice.unit",
                ""
              ),
              formatted: _.get(
                this.product,
                "defaultSku.priceInfo.salePrice.formatted",
                ""
              ),
            },
            priceType: _.get(
              this.product,
              "defaultSku.priceInfo.priceType",
              ""
            ),
            unitSalePrice: {
              unit: _.get(
                this.product,
                "defaultSku.priceInfo.unitSalePrice.unit",
                ""
              ),
              formatted: _.get(
                this.product,
                "defaultSku.priceInfo.unitSalePrice.formatted",
                ""
              ),
            },
            listPrice: {
              unit: _.get(
                this.product,
                "defaultSku.priceInfo.listPrice.unit",
                ""
              ),
              formatted: _.get(
                this.product,
                "defaultSku.priceInfo.listPrice.formatted",
                ""
              ),
            },
          },
          sceneSevenImage: _.get(
            this.product,
            "defaultSku.sceneSevenImage",
            ""
          ),
          thumbnailImageUrl: _.get(
            this.product,
            "defaultSku.thumbnailImageUrl",
            ""
          ),
          unitOfMeasure: _.get(this.product, "defaultSku.unitOfMeasure", ""),
          unitOfMeasureQuantity: _.get(
            this.product,
            "defaultSku.unitOfMeasureQuantity",
            ""
          ),
          unitWeight: _.get(this.product, "defaultSku.unitWeight", ""),
          weightSelectionIncrements: _.get(
            this.product,
            "defaultSku.weightSelectionIncrements",
            []
          ),
        },
        displayName: _.get(this.product, "displayName", ""),
        formattedSalePrice: _.get(this.product, "formattedSalePrice", ""),
        id: _.get(this.product, "id", ""),
        isAtStartingPrice: _.get(this.product, "isAtStartingPrice", false),
        isMakeReady: _.get(this.product, "isMakeReady", false),
        isPrimoPick: _.get(this.product, "isPrimoPick", false),
        isBestAvailable: _.get(this.product, "isBestAvailable", false),
        isOnAd: _.get(this.product, "isOnAd", false),
        mediumImageURL: _.get(this.product, "mediumImageURL", ""),
        onSale: _.get(this.product, "onSale", false),
        ownBrand: _.get(this.product, "mediumImageURL", false),
        pdpUrl: _.get(this.product, "pdpUrl", ""),
        productAvailableAtContext: _.get(
          this.product,
          "productAvailableAtContext",
          false
        ),
        randomWeight: _.get(this.product, "randomWeight", false),
        showOnlineMarketingBug: _.get(
          this.product,
          "showOnlineMarketingBug",
          false
        ),
        smallImageUrl: _.get(this.product, "smallImageUrl", false),
        snipes: _.get(this.product, "snipes", []), // Does this need more depth?
        storeAssortment: _.get(this.product, "storeAssortment", {}),
        thumbnailImageUrl: _.get(this.product, "thumbnailImageUrl", ""),
        thumbnailMediumImageUrl: _.get(
          this.product,
          "thumbnailMediumImageUrl",
          ""
        ),
      };
      return productSafe;
    },
    ariaLabel() {
      // Normal Product Card Attributes
      if (this.size == "normal") {
        var snipesAsText = [];
        this.productSafe.snipes.forEach(function (snipe) {
          snipesAsText.push(snipe.name);
        });

        return `
          ${this.productSafe.displayName.replace(/&#8209;/g, "")}
          ${this.productSafe.defaultSku.customerFriendlySize}
          ${
            this.productSafe.defaultSku.onSale
              ? `On Sale! ${this.productSafe.defaultSku.priceInfo.salePrice.formatted} ${this.productSafe.defaultSku.priceInfo.salePrice.unit}, Regularly ${this.productSafe.defaultSku.priceInfo.listPrice.formatted} ${this.productSafe.defaultSku.priceInfo.listPrice.unit}`
              : `${this.productSafe.defaultSku.priceInfo.listPrice.formatted} ${this.productSafe.defaultSku.priceInfo.listPrice.unit}`
          }.
          ${
            this.productSafe.defaultSku.priceInfo.unitListPrice.formatted
              .length && !this.productSafe.defaultSku.onSale
              ? `That's ${this.productSafe.defaultSku.priceInfo.unitListPrice.formatted}/${this.productSafe.defaultSku.priceInfo.unitListPrice.unit}.`
              : ""
          }
          ${
            this.productSafe.defaultSku.priceInfo.unitSalePrice.formatted
              .length && this.productSafe.defaultSku.onSale
              ? `That's ${this.productSafe.defaultSku.priceInfo.unitListPrice.formatted}/${this.productSafe.defaultSku.priceInfo.unitListPrice.unit}.`
              : ""
          }
          ${
            this.productSafe.defaultSku.availableCouponIds.length
              ? "coupon available."
              : ""
          }
          ${
            this.productSafe.snipes.length
              ? `Features: ${snipesAsText.join(", ").toLowerCase()}.`
              : ""
          }
          ${this.productSafe.isPrimoPick ? "Primo Pick." : ""}
        `;
      }

      // Small Product Card Attributes
      if (this.size == "small") {
        return `
          ${this.productSafe.displayName.replace(/&#8209;/g, "")}
          ${this.productSafe.defaultSku.customerFriendlySize}
          ${
            this.productSafe.defaultSku.onSale
              ? `${this.productSafe.defaultSku.priceInfo.salePrice.formatted} ${this.productSafe.defaultSku.priceInfo.salePrice.unit}`
              : `${this.productSafe.defaultSku.priceInfo.listPrice.formatted} ${this.productSafe.defaultSku.priceInfo.listPrice.unit}`
          }
        `;
      }
    },
    productDataIsGoodEnoughToDisplayCard() {
      // Cases for when we do not have sufficent data to show a product card or data would cause errors, such as an item missing a price or ID.
      try {
        if (this.product.id == 0) throw "has product.id of 0 which is invalid";
        if (this.product.defaultSku === undefined)
          throw "is missing defaultSku";
        if (this.product.defaultSku.priceInfo === undefined)
          throw "is missing defaultSku.priceInfo";
      } catch (error) {
        console.log(
          "ProductDataError: product " +
            error +
            " and will be hidden from view. ",
          this.product
        );
        return false;
      }

      return true; // Product data is good enough to show a productCard
    },
    productClass() {
      if (this.productClassName) {
        return this.productClassName;
      }
      if (this.size == "normal" && this.productSafe.isMakeReady) {
        return "responsivegriditem product-card makeready product-grid-large-3 product-grid-small-12 product-grid-medium-4";
      }
      if (this.size == "normal") {
        return "responsivegriditem product-card";
      }
      if (this.size == "medium") {
        return "product-card product-card--medium";
      }
      if (this.size == "small") {
        return "product-card product-card--small";
      }
    },
    flag() {
      // Display a flag in priority order
      // flag priority should be coupon, on sale, primo pick.
      // Optionally supply a function for when the flag is clicked

      // Has coupon
      if (this.productSafe.defaultSku.availableCouponIds.length) {
        return {
          imgUrl: "/img/flag-coupon.svg",
          class: "product-card__flag product-card__flag--coupon",
          onClick: this.seeCoupons,
        };
      }

      // is Best available product "representative product"
      if (this.productSafe.isBestAvailable) {
        return {
          imgUrl: "/img/flag-best-available.svg",
          class: "product-card__flag product-card__flag--best-available",
        };
      }

      // is on The weekly ad
      if (this.productSafe.isOnAd) {
        return {
          imgUrl: "/img/flag-on-ad.svg",
          class: "product-card__flag product-card__flag--on-ad",
        };
      }

      // is on Sale
      if (this.productSafe.onSale) {
        return {
          imgUrl: "/img/flag-on-sale.svg",
          class: "product-card__flag product-card__flag--on-sale",
        };
      }

      // Is Primo Pick
      if (this.productSafe.isPrimoPick) {
        return {
          imgUrl: "/img/flag-primo-pick.svg",
          class: "product-card__flag product-card__flag--primo-pick",
        };
      }
    },
    gtmImpressionClass() {
      //add gtm-product if the product card is not inside a carousel. If it is a carousel we need to track impressions differently with gtm-img
      return this.collection
        ? "cat-list-img gtm-img"
        : "cat-list-img gtm-product";
    },
    gtmImpressionClassSmall() {
      return this.collection
        ? "product-card__thumbnail-container gtm-img"
        : "product-card__thumbnail-container gtm-product";
    },
    formattedListName() {
      if (this.bucket === "orderAddOns") {
        return "add-ons:" + this.listname;
      } else {
        return this.listname;
      }
    },
    commerceItem() {
      if (typeof this.$store.state[this.bucket] === "undefined") {
        return;
      }
      var commerceItem = 0;

      // Look for cart commerce item by productSafe.id
      if (this.bucket === "cart") {
        var vm = this;

        this.$store.state.cart.commerceItems.forEach(function (category) {
          var item = category.items.find(function (item) {
            return item.id === vm.productSafe.id;
          });

          if (item) {
            commerceItem = item;
          }
        });

        return commerceItem;
      }

      // Lookup order add on commerce item by productSafe.id
      if (this.bucket === "orderAddOns") {
        var vm = this;

        var item = this.$store.state.orderAddOns.orderAddOn.commerceItems.find(
          function (item) {
            return item.productSafe.id === vm.productSafe.id;
          }
        );

        if (item) {
          commerceItem = item;
        }

        return commerceItem;
      }
    },
    quantityInBucket() {
      var qty = 0;

      if (this.commerceItem && !this.productSafe.pricedByWeight) {
        qty = this.commerceItem.quantity;
      }

      if (this.commerceItem && this.productSafe.pricedByWeight) {
        qty = this.commerceItem.estimatedWeight;
      }

      return qty;
    },
    bucketDisplayName() {
      switch (this.bucket) {
        default:
          return "Cart";
        case "cart":
          return "Cart";
        case "orderAddOns":
          return "Order";
      }
    },
    quantity() {
      // TODO: MOQ
      return 1;
    },
    activeShoppingList() {
      return heb.data.user.activeShoppingList.id;
    },
    lists() {
      let lists = [...heb.data.user.lists];

      // Add Wishlist
      lists.push(heb.data.user.wishList);

      // Add Manage my list button
      lists.push({
        id: null,
        name: "Manage My List",
      });

      return lists;
    },
    wishList() {
      return heb.data.user.wishList;
    },
    displayPreferences() {
      const hasPreferences =
        this.product.purchasePreferenceList &&
        this.product.purchasePreferenceList.purchasePreferences.length;
      return (
        !this.hidePreferences && hasPreferences && this.product.addToCartAllowed
      );
    },
  },
  methods: {
    handleProductLink() {
      switch (this.productLinkDestination) {
        case "link":
          this.gtmClick(
            PRODUCT_CLICK_EVENT,
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          this.gtmClick(
            PDP_CLICK_THROUGH_EVENT,
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          window.location = this.productSafe.pdpUrl;
          break;
        case "modal":
          this.gtmClick(
            PRODUCT_CLICK_EVENT,
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          this.gtmClick(
            PDP_CLICK_THROUGH_EVENT,
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          this.gtmClick(
            "e_productDetailView",
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          this.hupOpenModal({
            modalId: "product-detail",
            productId: this.productSafe.id,
            bucket: this.bucket,
          });
          break;

        case "productDetailModalOverOrderDetailPage":
          this.gtmClick(
            PRODUCT_CLICK_EVENT,
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          this.gtmClick(
            "e_productDetailView",
            this.product,
            this.bucket,
            this.listname,
            "",
            "spa",
            this.position,
            this.reco
          );
          window.location =
            "/my-account/order-history/add-on/" +
            this.$store.state.cart.id +
            "?modalId=product-detail&productId=" +
            this.productSafe.id +
            "&bucket=orderAddOns";

          break;
      }
    },
    addItemToBucket: function () {
      if (this.productSafe.pricedByWeight) {
        var item = {
          productId: this.productSafe.id,
          skuId: this.productSafe.defaultSku.id,
          quantity: this.quantity,
          weight: this.weight,
        };
      } else {
        var item = {
          productId: this.productSafe.id,
          skuId: this.productSafe.defaultSku.id,
          quantity: this.quantity,
        };
      }

      this.$store.dispatch(this.bucket + "/ADD_ITEM_TO_BUCKET", item);
    },
    addItemToList(listId = this.activeShoppingList, listName = null) {
      if (this.productSafe.pricedByWeight) {
        var item = {
          productId: this.productSafe.id,
          skuId: this.productSafe.defaultSku.id,
          quantity: this.quantity,
          weight: this.weight,
          listId: listId,
        };
      } else {
        var item = {
          productId: this.productSafe.id,
          skuId: this.productSafe.defaultSku.id,
          quantity: this.quantity,
          listId: listId,
        };
      }

      this.$store
        .dispatch("cart/ADD_ITEM_TO_LIST", { item, listName })
        .then(() => {
          this.toggleLists();
        });

      this.gtmClick(
        PRODUCT_ADD_TO_LIST_EVENT,
        this.product,
        this.bucket,
        this.listname,
        this.quantityInBucket,
        this.buttonType,
        this.position,
        "default"
      );
    },
    seeCoupons() {
      if (
        this.productSafe.defaultSku.availableCouponIds &&
        this.productSafe.defaultSku.availableCouponIds.length > 1
      ) {
        // open Coupon Modal
      } else {
        // slide in the coupon clipper
        this.showCouponPopup = !this.showCouponPopup;
      }
    },
    closeCouponPopup() {
      this.showCouponPopup = false;
    },
    decrement() {
      // TODO use _.debounce to limit this
      if (this.productSafe.pricedByWeight) {
        this.deleteItem(this.commerceItem.id);
        return;
      }

      this.$store.commit(
        this.bucket + "/DECREMENT_ITEM_QUANTITY",
        this.commerceItem
      );
    },
    increment() {
      if (
        !this.productSafe.addToCartDisabled &&
        !this.options.overrideAddToBucket
      ) {
        if (this.quantityInBucket == 0) {
          this.addItemToBucket();
          return;
        }
        // TODO use _.debounce to limit this
        // this.$store.commit('cart/INCREMENT_ITEM_QUANTITY', this.commerceItem)

        this.$store.commit(
          this.bucket + "/INCREMENT_ITEM_QUANTITY",
          this.commerceItem
        );
      }
    },
    deleteItem: function (id) {
      this.$store.dispatch("cart/DELETE_ITEM", id);
    },
    addToListButton() {
      if (this.lists.length === 1) {
        this.addItemToList(
          this.activeShoppingList.id,
          this.activeShoppingList.name
        );
      } else {
        this.toggleLists();
      }
    },
    toggleLists() {
      this.showLists = !this.showLists;

      if (this.showLists) {
        // Focus first element of list
        this.$nextTick(() => {
          this.$refs.listItem[0].focus();
          window.addEventListener("click", this.closeFromWindow);
        });
      } else {
        window.removeEventListener("click", this.closeFromWindow);
        this.$refs.addToListButtonRef.focus();
      }
    },
    closeLists() {
      this.showLists = false;
      this.$nextTick(() => {
        window.removeEventListener("click", this.closeFromWindow);
        this.$refs.addToListButtonRef.focus();
      });
    },
    changeFocus(e) {
      this.focusedRef = e.target;
    },
    nextListItem(direction) {
      let curIndex = parseInt(this.focusedRef.getAttribute("data-ref-index"));
      const nextIndex = direction === "next" ? curIndex + 1 : curIndex - 1;
      this.focusListItem(nextIndex);
    },
    focusListItem(nextIndex) {
      const numLists = this.$refs.listItem.length;
      this.$nextTick(() => {
        this.$refs.listItem[this.mod(nextIndex, numLists)].focus();
      });
    },
    mod(a, b) {
      return ((a % b) + b) % b;
    },
    closeFromWindow(e) {
      if (!this.$el.contains(e.target)) {
        this.closeLists();
      }
    },
  },
  destroyed() {
    window.removeEventListener("click", this.closeFromWindow);
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/lib";
@import "../../scss/_promo-flag";
@import "../../../../static-assets/css/_btn.scss";
@import "../../../../static-assets/css/_product-card.scss";

.product-card {
  display: flex !important; //Override slick carousel
  background-color: #fff;
  position: relative;

  &__thumbnail-container {
    width: 80px;
    height: 80px;
    margin-right: 4px;
    flex-shrink: 0;
  }

  &__content-container {
    flex-basis: 100%;
    flex-grow: 1;
  }

  &__thumbnail {
    max-width: 100%;
  }

  &__title {
    max-height: 2rem;
    overflow: hidden;
    display: block;

    // Ellipsis for browsers that support it
    display: -webkit-box;
    -webkit-box-orient: vertical; //TODO: figure out why this is getting stripped out
    box-orient: vertical;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
  }

  &__price {
    font-weight: 700;
  }

  &__strikethrough {
    height: 16px;
    text-decoration: line-through;
  }

  &__unit {
    opacity: 0.75;
  }

  &__btn-container {
    display: flex;
    // background-color: $color-heb-primary;
    border-radius: 4px;
  }

  &__cart-actions {
    flex-grow: 1;
  }

  .btn-add-to-cart,
  .btn-decrement {
    border: 0;
    margin: 0;
    color: #fff;
    background-color: $color-heb-primary;
    height: 38px;

    &:hover {
      background-color: darken($color-heb-primary, 10%);
    }
  }

  .btn-add-to-cart {
    flex-grow: 1;
    flex-basis: 100%;
    width: 100%;
    padding: 8px 1rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-justify-content: center;
  }

  .product-card__flag {
    z-index: 10;
    position: absolute;
    top: 6px;
    left: 5px;
    max-height: 38px; //s7 @2x
  }
}

.product-card--medium {
  flex-direction: column;
  padding: $padding-small;
  // width: 192px;
  height: 100%;
  border: 1px solid #eeecec;
  border-radius: 6px;
  color: #414142;

  .product-card {
    &__top {
      height: auto;
      max-height: 135px;
      min-height: 135px; // loading jump
      position: relative;
      margin-bottom: 0.5rem;
      text-align: center;
    }

    &__features {
      z-index: 1;
      position: absolute;
      right: 0;
      top: 0;
      max-height: 166px;
      overflow: hidden;

      img {
        border-radius: 100%;
        padding: 2px;
        width: 32px;
        height: 32px;
        display: block;
      }
    }

    &__flag {
      z-index: 10;
      position: absolute;
      top: 0;
      left: 0;
    }

    &__thumbnail {
      height: auto;
      max-height: 135px;
      width: 100%;
      max-width: 135px;
      margin: 0 auto;
    }

    &__meta {
      text-align: center;
    }

    &__display-name {
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      color: #414142;
      margin-bottom: 0.5rem;
      flex-grow: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 2.125rem;
      overflow: hidden;
    }

    &__on-sale {
      .list-price {
        font-size: 11px;
        text-decoration: line-through;
        color: #818181;
      }

      .sale-price {
        color: #dc2a27;
      }
    }

    &__thumbnail-container {
      width: 65px;
      height: 65px;
    }

    &__price-container {
      height: 2.1rem;
      display: flex;
      justify-content: center;
      line-height: 1.25;
    }
  }
}

.product-card--small {
  flex-direction: column;
  padding: $padding-small;
  margin: 0;
  width: 192px;
  height: 100%;

  .product-card {
    &__meta {
      margin-bottom: 0.5rem;
      flex-grow: 1;
    }

    &__thumbnail-container {
      width: 65px;
      height: 65px;
    }

    &__description {
      font-size: 0.8125rem;
      line-height: 1rem;
      max-height: 3rem;
      overflow: hidden;
    }
  }
}

.product-collection--horizontal {
  .product-card--small {
    border: 1px solid $color-border-standard-gray;
    border-radius: $padding-small/2;
  }
}

.product-collection--sidebar {
  .product-card--small {
    width: 100%;
    margin: 0;
  }
}

.product-grid-large-fifth {
  width: calc(50% - 8px);
  border-radius: 4px;
  max-width: 197.5px;
}

.product-grid {
  .product-grid-large-fifth {
    max-width: none;
  }

  &--override-min-width {
    .product-grid-large-fifth {
      min-width: auto;
    }
  }
}

.coupon-detail-modal .products .product-card--small {
  padding-bottom: $padding-small !important;

  .product-card__cart-actions {
    position: initial !important;
  }
}

@media all and (min-width: $breakpoint-tablet) {
  .product-grid-large-fifth {
    width: calc(33.33% - 16px);
    margin: 8px;
  }
}

@media all and (min-width: $breakpoint-desktop) {
  .product-grid-large-fifth {
    width: calc(25% - 16px);
  }
}

@media all and (min-width: $breakpoint-desktop-large) {
  .product-grid-large-fifth {
    width: calc(20% - 16px);
  }
}
</style>

<style lang="scss" scoped>
// Center a fixed-width image within its container
// This method ensures that the image can remain centered even when
// the bounding box is smaller than the image
.cat-list-img img {
  left: -100px;
  right: -100px;
  position: absolute;
  margin: 0 auto;
  top: 0;
}

.promo-flag,
.cat-feature-marketing,
.cat-feature-list {
  z-index: 1;
}
.list-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0;
  left: 0;
}
.atl-container-triangle {
  transform: rotate(180deg) translateY(1px);
  width: 100%;
  background: url(/img/common/atl-container-triangle-border.png) no-repeat
    center bottom transparent;
  height: 13px;
}

.atl-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: auto;
  bottom: -35px;
  position: relative;
  left: 0;
  height: 80%;
  width: 90%;
  z-index: 2;
  top: auto;
  &.overflow {
    display: block;
    ul {
      height: 100%;
      overflow: scroll;
      justify-content: flex-start;
      border: solid 1px rgb(238, 238, 238);
    }
  }

  ul {
    text-align: center;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0px;

    li {
      padding: 0;
      flex-shrink: 0;
      background-color: #fff;
      border: 1px solid #ececec;
      color: #8b8b8b;
      width: 100%;
      padding: 10px 5px !important;
      margin: -1px 0 0;
      min-height: 16px !important;
      float: none;
      &:hover {
        background-color: #f8f8f8 !important;
        font-style: italic;
      }
    }
    button,
    a:link {
      -webkit-appearance: none;
      background: none;
      color: inherit;
      width: 100%;
      height: 100%;
      padding: 10px 5px !important;
      margin: 0;
      color: #333;
      line-height: normal;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border: none;
      display: block;
      &:hover {
        background-color: #f8f8f8 !important;
        font-style: italic;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<docs>
#bucket
can be 'cart' or 'order'.
used for finding how many of x you have in your cart. for add-to-cart button ex "2.25 lb added"
</docs>
